import React from 'react'
import Icon from './IconBase'

const Wallet = props => (
  <Icon viewBox="0 0 19 19" fill="none" {...props}>
    <path
      d="M15.4375 5.34375H3.5625C2.57874 5.34375 1.78125 6.14124 1.78125 7.125V14.25C1.78125 15.2338 2.57874 16.0312 3.5625 16.0312H15.4375C16.4213 16.0312 17.2188 15.2338 17.2188 14.25V7.125C17.2188 6.14124 16.4213 5.34375 15.4375 5.34375Z"
      stroke="currentColor"
      strokeWidth="1.1875"
      strokeLinejoin="round"
    />
    <path
      d="M15.2653 5.34364V4.23036C15.2652 3.95731 15.2049 3.68765 15.0886 3.44061C14.9723 3.19357 14.8029 2.97525 14.5925 2.80121C14.3821 2.62718 14.1359 2.50173 13.8714 2.43381C13.6069 2.36589 13.3307 2.35717 13.0625 2.40829L3.28938 4.07636C2.86496 4.15724 2.48208 4.38369 2.20676 4.71666C1.93145 5.04962 1.78096 5.46823 1.78125 5.90028V7.71864"
      stroke="currentColor"
      strokeWidth="1.1875"
      strokeLinejoin="round"
    />
    <path
      d="M13.6563 11.875C13.4214 11.875 13.1918 11.8054 12.9965 11.6749C12.8012 11.5444 12.649 11.3589 12.5591 11.1419C12.4693 10.925 12.4457 10.6862 12.4916 10.4558C12.5374 10.2255 12.6505 10.0139 12.8166 9.84781C12.9826 9.68174 13.1942 9.56864 13.4246 9.52282C13.6549 9.477 13.8937 9.50051 14.1107 9.59039C14.3277 9.68027 14.5131 9.83248 14.6436 10.0278C14.7741 10.223 14.8438 10.4526 14.8438 10.6875C14.8438 11.0024 14.7186 11.3045 14.4959 11.5272C14.2732 11.7499 13.9712 11.875 13.6563 11.875Z"
      fill="currentColor"
    />
  </Icon>
)

export default Wallet
